import { AxiosInstance, AxiosPromise } from 'axios';
import {
  CreateReportRequest,
  ReportEndpoints,
  CreateReportResponse,
  GetReportResponse,
  GetReportsResponse,
  UpdateReportRequest,
  UpdateReportResponse,
  DeleteReportResponse,
  GetReportsRequest,
} from './ReportServices.types';

import { ExportReportServices } from './services';

export class ReportServices implements ReportEndpoints {
  instance: AxiosInstance;
  exports: ExportReportServices;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.exports = new ExportReportServices(instance);
  }

  get(request: GetReportsRequest): AxiosPromise<GetReportsResponse> {
    return this.instance.get('/reports', {
      params: request.queryParams,
    });
  }

  getById(reportId: string): AxiosPromise<GetReportResponse> {
    return this.instance.get(`/reports/${reportId}`);
  }

  create(request: CreateReportRequest): AxiosPromise<CreateReportResponse> {
    return this.instance.post('/reports', request.body);
  }

  update(request: UpdateReportRequest): AxiosPromise<UpdateReportResponse> {
    return this.instance.patch(`/reports/${request.routeParams.id}`, request.body);
  }

  delete(reportId: string): AxiosPromise<DeleteReportResponse> {
    return this.instance.delete(`/reports/${reportId}`);
  }
}
